import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd';
import request from '../../utils/request';
import InstructionFinalReviewPage from './FinalReview';
import NonStdFinalReview from './NonStdFinalReview';

/**
 * 终审页入口：库存非标准操作指令走自己的终审页，其他所有指令仍然进入原来的终审页（原页面一行不改）。
 * 判断依据是指令创建时固化的模板快照里的 meta.engine，不看模板名称。
 */
const FinalReviewSwitch: React.FC = () => {
  const { id } = useParams();
  const instructionId = Number(id);
  const [engine, setEngine] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setEngine(null);
    (async () => {
      try {
        const res = await request.get(`/api/v1/instruction/instructions/${instructionId}/`);
        const found = String(res.data?.template_snapshot?.meta?.engine || res.data?.template_detail?.meta?.engine || '');
        if (!cancelled) setEngine(found || 'standard');
      } catch {
        // 取不到就当标准指令，进入原来的终审页（它自己会处理加载失败）
        if (!cancelled) setEngine('standard');
      }
    })();
    return () => { cancelled = true; };
  }, [instructionId]);

  if (engine === null) return <div style={{ textAlign: 'center', padding: 48 }}><Spin /></div>;
  if (engine === 'nonstandard_ops') return <NonStdFinalReview instructionId={instructionId} />;
  return <InstructionFinalReviewPage />;
};

export default FinalReviewSwitch;
